import EmptyState from '@/components/EmptyState';
import { useLabels } from '@/features/labels/hooks/useLabels';
import { safeLabelColor } from '@/features/labels/utils/label-color';
import { useT } from '@/i18n';
import {
  Block,
  BlockFooter,
  List,
  ListItem,
  Navbar,
  NavRight,
  Link as F7Link,
  Page,
  Preloader,
  f7,
} from 'framework7-react';
import { useSettingsDetailBackLink } from '@/utils/useMediaQuery';

function LabelsSettingsPage() {
  const ol = useT().labels;
  const settingsBackLink = useSettingsDetailBackLink();
  const { data: labels, isLoading, error } = useLabels();

  const goToForm = (path: string) => f7.views.current.router.navigate(path);

  return (
    <Page name="labels-settings">
      <Navbar title={ol.pageTitle} backLink={settingsBackLink}>
        <NavRight>
          <F7Link iconF7="plus" onClick={() => goToForm('/settings/labels/new')} />
        </NavRight>
      </Navbar>

      {isLoading && (
        <Block className="text-align-center">
          <Preloader />
        </Block>
      )}
      {error && (
        <EmptyState
          icon="exclamationmark_triangle"
          iconColor="#ff9500"
          title={ol.couldntLoadLabels}
          description={(error as Error).message}
        />
      )}

      {labels && labels.length === 0 && (
        <EmptyState icon="tag" title={ol.noLabelsTitle} description={ol.noLabelsDescription} />
      )}

      {labels && labels.length > 0 && (
        <>
          <List strongIos strongMd insetIos insetMd dividersIos dividersMd>
            {labels.map((label) => (
              <ListItem
                key={label.id}
                title={label.name}
                link="#"
                onClick={() => goToForm(`/settings/labels/${label.id}`)}
              >
                <div slot="media">
                  <span
                    style={{
                      display: 'block',
                      width: 22,
                      height: 22,
                      borderRadius: '50%',
                      background: safeLabelColor(label.color),
                    }}
                  />
                </div>
              </ListItem>
            ))}
          </List>
          <BlockFooter>{ol.listFooter}</BlockFooter>
        </>
      )}
    </Page>
  );
}

export default LabelsSettingsPage;
